import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { TCCPConstantValues } from '../../shared/models/tccp-constants';
import { TCCPLoggerService } from '../../shared/services/tccp-logger.service';
import { TCCPHttpService } from '../../shared/services/tccp-http.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageCategoryMappingService {

  constructor(private logger: TCCPLoggerService, private httpService: TCCPHttpService) { }

  public appBase = TCCPConstantValues[environment.applicationName];
  getCategoryMapping(source) {
    this.logger.logMethodStart(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
      'Started getting Error Messages', '');
    const url = this.appBase.Urls.CATEGORY_MAPPING;
    return this.httpService.get(url + '?source=' + source).pipe(
      map((data: any) => {
          this.logger.logMethodEnd(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting Error Messages successful', JSON.stringify(data));
          return data;
        }),
        catchError((error: any) => {
          this.logger.logException(this.appBase.modules.FLOW_MODULE, this.appBase.methods.getFlow,
            'Getting Error Messages failed', '', error);
          return error;
        })
    );
  }
}
